import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type organizationsAdminPermissionType = 'organizations_admin_view';

export const organizationsAdminPermissionMatrix: IPermissionMatrix<organizationsAdminPermissionType> = {
  organizations_admin_view: [UserRole.admin]
};
